import { render, staticRenderFns } from "./BoardsPublicView.vue?vue&type=template&id=9bea3682&scoped=true"
import script from "./BoardsPublicView.vue?vue&type=script&lang=js"
export * from "./BoardsPublicView.vue?vue&type=script&lang=js"
import style0 from "./BoardsPublicView.vue?vue&type=style&index=0&id=9bea3682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bea3682",
  null
  
)

export default component.exports